import api from '@/api'
import * as types from '../mutation-types'

// initial state
const state = {
  all: null
}

// getters
const getters = {
  getAllFakultasData: state => state
}

// actions
const actions = {
  getAllFakultas ({ commit }) {
    api.get('/v1/public/fakultas')
      .then(response => {
        let responseData = response.data
        commit(types.FAKULTAS_RECIEVE, responseData.data)
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        console.log(e)
      })
  }
}

// mutations
const mutations = {
  [types.FAKULTAS_RECIEVE] (state, response) {
    state.all = response
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/fakultas.js